const enPH = {
  "app.language": "Language",
  "language.enPH": "English",
  "language.zhTW": "Traditional Chinese",

  "nav.attendance": "Attendance",
  "nav.management": "Management",
  "nav.classrooms": "Classrooms",
  "nav.gradeSections": "Grade/Sections",
  "nav.students": "Students",
  "nav.reports": "Reports",
  "nav.attendanceReport": "Attendance Report",

  "profile.email": "Email",
  "profile.school": "School",
  "profile.job": "Job",
  "profile.role": "Role",

  "auth.id": "ID",
  "auth.password": "Password",
  "auth.signin": "Sign in",
  "auth.signout": "Sign out",
  "auth.requiredId": "Please input ID",
  "auth.requiredPassword": "Please input password",
  "auth.invalidLogin": "Invalid login name or password",

  "common.actions": "Actions",
  "common.add": "Add",
  "common.cancel": "Cancel",
  "common.confirm": "Confirm",
  "common.confirmation": "Confirmation",
  "common.delete": "Delete",
  "common.close": "Close",
  "common.update": "Update",
  "common.register": "Register",
  "common.notice": "Notice",
  "common.warning": "Warning",
  "common.ok": "OK",
  "common.loading": "Loading...",
  "common.generating": "Generating...",
  "common.doUpdate": "Do you want to update?",
  "common.doRegister": "Do you want to register?",
  "common.doDeleteWarning":
    "Do you want to delete? This action cannot be undone.",
  "common.successUpdated": "Success Updated",
  "common.successRegistered": "Success Registered",
  "common.successDeleted": "Success Delete",

  "field.id": "ID",
  "field.name": "Name",
  "field.grade": "Grade",
  "field.section": "Section",
  "field.grades": "Grades",
  "field.sections": "Sections",
  "field.year": "Year",
  "field.month": "Month",
  "field.firstName": "First Name",
  "field.lastName": "Last Name",
  "field.gender": "Gender",
  "field.male": "Male",
  "field.female": "Female",
  "field.other": "Other",
  "field.roomNumber": "Room Number",
  "field.roomName": "Room Name",
  "field.gradeName": "Grade Name",
  "field.sectionName": "Section Name",
  "field.zipcode": "Zipcode",
  "field.prefecturers": "Prefectures",
  "field.address": "Address",

  "month.january": "January",
  "month.february": "February",
  "month.march": "March",
  "month.april": "April",
  "month.may": "May",
  "month.june": "June",
  "month.july": "July",
  "month.august": "August",
  "month.september": "September",
  "month.october": "October",
  "month.november": "November",
  "month.december": "December",

  "attendance.title": "Attendance",
  "attendance.updateTime": "Update time {{time}}",
  "attendance.emptyName": "<Empty Name>",
  "attendance.column.stay": "Stay",
  "attendance.column.distance": "Distance",
  "attendance.column.battery": "Battery",
  "attendance.column.firstReceiveTime": "First Receive Time",
  "attendance.column.lastReceiveTime": "Last Receive Time",

  "classrooms.title": "Classrooms",
  "classrooms.addTitle": "Add Classroom",
  "classrooms.editTitle": "Edit Classroom",
  "classrooms.deleteTitle": "Delete Classroom",
  "classrooms.deleteMessage": "Are you sure you want to delete this classroom?",
  "classrooms.selectToDelete": "Please select a classroom to delete.",

  "gradeSections.title": "Grade/Sections",
  "grades.addTitle": "Add Grade",
  "grades.editTitle": "Edit Grade",
  "grades.deleteTitle": "Delete Grade",
  "grades.deleteMessage": "Are you sure you want to delete this grade?",
  "grades.selectToDelete": "Please select a grade to delete.",
  "sections.addTitle": "Add Section",
  "sections.editTitle": "Edit Section",
  "sections.deleteTitle": "Delete Section",
  "sections.deleteMessage": "Are you sure you want to delete this section?",
  "sections.selectToDelete": "Please select a section to delete.",

  "students.title": "Students",
  "students.addTitle": "Add Student",
  "students.editTitle": "Edit Student",
  "students.deleteTitle": "Delete Student",
  "students.deleteMessage": "Are you sure you want to delete this student?",
  "students.selectToDelete": "Please select a student to delete.",
  "students.importCsv": "Import CSV Data",
  "students.information": "Student Information",
  "students.gradeSectionInformation": "Grade/Section Information",
  "students.selectGrade": "Please select a grade",
  "students.selectSection": "Please select a section",

  "csv.title": "CSV Data Import",
  "csv.selectFile": "Select CSV File",
  "csv.selectedFile": "Selected file: {{fileName}}",
  "csv.formatRequirements": "CSV Format Requirements:",
  "csv.requiredColumns": "Required columns:",
  "csv.genderRequirement": "Gender: MALE or FEMALE",
  "csv.uuidRequirement":
    "UUID: Standard UUID format (xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx)",
  "csv.majorMinorRequirement":
    "Major/Minor: Numbers between 0 and 65535 (for beacon identification)",
  "csv.beaconDataRequirement":
    "Beacon Data: If providing beacon information, UUID, Major, and Minor are all required",
  "csv.availableGrades": "Available Grades:",
  "csv.availableSections": "Available Sections:",
  "csv.loadingGradeSections": "Loading available grades and sections...",
  "csv.validationErrors": "Validation Errors ({{count}}):",
  "csv.importResults": "Import Results:",
  "csv.importedCount": "Successfully imported: {{count}} students",
  "csv.failedCount": "Failed to import: {{count}} students",
  "csv.errorDetails": "Error Details:",
  "csv.rowError": "Row {{row}}, {{field}}: {{message}}",
  "csv.rowErrorSimple": "Row {{row}}: {{message}}",
  "csv.preview": "CSV Preview ({{count}} rows)",
  "csv.validationErrorCount": "- {{count}} validation error(s)",
  "csv.moreRows": "... and {{count}} more rows",
  "csv.importData": "Import Data",
  "csv.importing": "Importing...",
  "csv.importComplete": "Import Complete",
  "csv.selectCsvError": "Please select a CSV file",
  "csv.emptyFileError": "CSV file is empty",
  "csv.parseError": "Failed to parse CSV file",
  "csv.missingRequiredColumns":
    "Missing required columns: {{missingColumns}}. Required columns are: {{requiredColumns}}",
  "csv.requiredField": "{{field}} is required",
  "csv.genderError": "Gender should be MALE or FEMALE",
  "csv.gradeError": "Grade should be one of: {{values}}",
  "csv.sectionError": "Section should be one of: {{values}}",
  "csv.uuidError":
    "Invalid UUID format (expected: xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx)",
  "csv.majorError": "Major must be a number between 0 and 65535",
  "csv.minorError": "Minor must be a number between 0 and 65535",
  "csv.beaconRequiredError":
    "If providing beacon data, UUID, Major, and Minor are all required",
  "csv.noDataError": "No data to import",
  "csv.fixValidationError": "Please fix validation errors before importing",
  "csv.partialSuccess":
    "Import completed with some errors. {{successCount}} successful, {{failedCount}} failed.",
  "csv.importFailed": "Import failed",
  "csv.importDataFailed": "Failed to import data",

  "beacon.addTitle": "Add Beacon",
  "beacon.editTitle": "Edit Beacon",
  "beacon.uuid": "UUID",
  "beacon.major": "Major",
  "beacon.minor": "Minor",

  "notFound.title": "Not Found Page",

  "report.attendanceTitle": "Attendance Report",
  "report.generateMonthly": "Generate Monthly Attendance Report",
  "report.generate": "Generate Report",
  "report.selected": "Selected:",
  "report.requiredGradeSection": "Please select both Grade and Section",
  "report.loadGradeSectionsError": "Failed to load grades and sections",
  "report.generateError": "Failed to generate report. Please try again.",
  "report.excelReadyTitle": "Excel File Ready",
  "report.excelGeneratedTitle": "Excel File Generated Successfully!",
  "report.excelGeneratedMessage":
    "Your attendance report has been generated and is ready for download. Click the download button below to save the file to your device.",
  "report.fileName": "File Name:",
  "report.fileSize": "File Size:",
  "report.fileType": "File Type:",
  "report.excelWorkbook": "Excel Workbook (.xlsx)",
  "report.downloadExcel": "Download Excel File",
};

const zhTW: Record<keyof typeof enPH, string> = {
  "app.language": "語言",
  "language.enPH": "英文",
  "language.zhTW": "繁體中文",

  "nav.attendance": "出勤",
  "nav.management": "管理",
  "nav.classrooms": "教室",
  "nav.gradeSections": "年級／班級",
  "nav.students": "學生",
  "nav.reports": "報表",
  "nav.attendanceReport": "出勤報表",

  "profile.email": "電子郵件",
  "profile.school": "學校",
  "profile.job": "職務",
  "profile.role": "角色",

  "auth.id": "帳號",
  "auth.password": "密碼",
  "auth.signin": "登入",
  "auth.signout": "登出",
  "auth.requiredId": "請輸入帳號",
  "auth.requiredPassword": "請輸入密碼",
  "auth.invalidLogin": "登入名稱或密碼無效",

  "common.actions": "操作",
  "common.add": "新增",
  "common.cancel": "取消",
  "common.confirm": "確認",
  "common.confirmation": "確認",
  "common.delete": "刪除",
  "common.close": "關閉",
  "common.update": "更新",
  "common.register": "登錄",
  "common.notice": "通知",
  "common.warning": "警告",
  "common.ok": "確定",
  "common.loading": "載入中...",
  "common.generating": "產生中...",
  "common.doUpdate": "要更新嗎？",
  "common.doRegister": "要登錄嗎？",
  "common.doDeleteWarning": "要刪除嗎？此操作無法復原。",
  "common.successUpdated": "更新成功",
  "common.successRegistered": "登錄成功",
  "common.successDeleted": "刪除成功",

  "field.id": "ID",
  "field.name": "姓名",
  "field.grade": "年級",
  "field.section": "班級",
  "field.grades": "年級",
  "field.sections": "班級",
  "field.year": "年份",
  "field.month": "月份",
  "field.firstName": "名字",
  "field.lastName": "姓氏",
  "field.gender": "性別",
  "field.male": "男",
  "field.female": "女",
  "field.other": "其他",
  "field.roomNumber": "教室編號",
  "field.roomName": "教室名稱",
  "field.gradeName": "年級名稱",
  "field.sectionName": "班級名稱",
  "field.zipcode": "郵遞區號",
  "field.prefecturers": "縣市",
  "field.address": "地址",

  "month.january": "一月",
  "month.february": "二月",
  "month.march": "三月",
  "month.april": "四月",
  "month.may": "五月",
  "month.june": "六月",
  "month.july": "七月",
  "month.august": "八月",
  "month.september": "九月",
  "month.october": "十月",
  "month.november": "十一月",
  "month.december": "十二月",

  "attendance.title": "出勤",
  "attendance.updateTime": "更新時間 {{time}}",
  "attendance.emptyName": "<空白姓名>",
  "attendance.column.stay": "停留",
  "attendance.column.distance": "距離",
  "attendance.column.battery": "電量",
  "attendance.column.firstReceiveTime": "首次接收時間",
  "attendance.column.lastReceiveTime": "最後接收時間",

  "classrooms.title": "教室",
  "classrooms.addTitle": "新增教室",
  "classrooms.editTitle": "編輯教室",
  "classrooms.deleteTitle": "刪除教室",
  "classrooms.deleteMessage": "確定要刪除此教室嗎？",
  "classrooms.selectToDelete": "請選擇要刪除的教室。",

  "gradeSections.title": "年級／班級",
  "grades.addTitle": "新增年級",
  "grades.editTitle": "編輯年級",
  "grades.deleteTitle": "刪除年級",
  "grades.deleteMessage": "確定要刪除此年級嗎？",
  "grades.selectToDelete": "請選擇要刪除的年級。",
  "sections.addTitle": "新增班級",
  "sections.editTitle": "編輯班級",
  "sections.deleteTitle": "刪除班級",
  "sections.deleteMessage": "確定要刪除此班級嗎？",
  "sections.selectToDelete": "請選擇要刪除的班級。",

  "students.title": "學生",
  "students.addTitle": "新增學生",
  "students.editTitle": "編輯學生",
  "students.deleteTitle": "刪除學生",
  "students.deleteMessage": "確定要刪除此學生嗎？",
  "students.selectToDelete": "請選擇要刪除的學生。",
  "students.importCsv": "匯入 CSV 資料",
  "students.information": "學生資訊",
  "students.gradeSectionInformation": "年級／班級資訊",
  "students.selectGrade": "請選擇年級",
  "students.selectSection": "請選擇班級",

  "csv.title": "CSV 資料匯入",
  "csv.selectFile": "選擇 CSV 檔案",
  "csv.selectedFile": "已選擇檔案：{{fileName}}",
  "csv.formatRequirements": "CSV 格式需求：",
  "csv.requiredColumns": "必填欄位：",
  "csv.genderRequirement": "性別：MALE 或 FEMALE",
  "csv.uuidRequirement":
    "UUID：標準 UUID 格式（xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx）",
  "csv.majorMinorRequirement":
    "Major/Minor：0 到 65535 之間的數字（用於 Beacon 識別）",
  "csv.beaconDataRequirement":
    "Beacon 資料：若提供 Beacon 資訊，UUID、Major、Minor 皆為必填",
  "csv.availableGrades": "可用年級：",
  "csv.availableSections": "可用班級：",
  "csv.loadingGradeSections": "正在載入可用年級和班級...",
  "csv.validationErrors": "驗證錯誤（{{count}}）：",
  "csv.importResults": "匯入結果：",
  "csv.importedCount": "成功匯入：{{count}} 位學生",
  "csv.failedCount": "匯入失敗：{{count}} 位學生",
  "csv.errorDetails": "錯誤詳細資訊：",
  "csv.rowError": "第 {{row}} 列，{{field}}：{{message}}",
  "csv.rowErrorSimple": "第 {{row}} 列：{{message}}",
  "csv.preview": "CSV 預覽（{{count}} 列）",
  "csv.validationErrorCount": "- {{count}} 個驗證錯誤",
  "csv.moreRows": "... 還有 {{count}} 列",
  "csv.importData": "匯入資料",
  "csv.importing": "匯入中...",
  "csv.importComplete": "匯入完成",
  "csv.selectCsvError": "請選擇 CSV 檔案",
  "csv.emptyFileError": "CSV 檔案是空的",
  "csv.parseError": "無法解析 CSV 檔案",
  "csv.missingRequiredColumns":
    "缺少必填欄位：{{missingColumns}}。必填欄位為：{{requiredColumns}}",
  "csv.requiredField": "{{field}} 為必填",
  "csv.genderError": "性別必須為 MALE 或 FEMALE",
  "csv.gradeError": "年級必須為以下之一：{{values}}",
  "csv.sectionError": "班級必須為以下之一：{{values}}",
  "csv.uuidError":
    "UUID 格式無效（應為：xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx）",
  "csv.majorError": "Major 必須是 0 到 65535 之間的數字",
  "csv.minorError": "Minor 必須是 0 到 65535 之間的數字",
  "csv.beaconRequiredError":
    "若提供 Beacon 資料，UUID、Major、Minor 皆為必填",
  "csv.noDataError": "沒有可匯入的資料",
  "csv.fixValidationError": "請先修正驗證錯誤再匯入",
  "csv.partialSuccess":
    "匯入已完成但有部分錯誤。成功 {{successCount}} 筆，失敗 {{failedCount}} 筆。",
  "csv.importFailed": "匯入失敗",
  "csv.importDataFailed": "資料匯入失敗",

  "beacon.addTitle": "新增 Beacon",
  "beacon.editTitle": "編輯 Beacon",
  "beacon.uuid": "UUID",
  "beacon.major": "Major 值",
  "beacon.minor": "Minor 值",

  "notFound.title": "找不到頁面",

  "report.attendanceTitle": "出勤報表",
  "report.generateMonthly": "產生每月出勤報表",
  "report.generate": "產生報表",
  "report.selected": "已選擇：",
  "report.requiredGradeSection": "請同時選擇年級和班級",
  "report.loadGradeSectionsError": "無法載入年級和班級",
  "report.generateError": "無法產生報表。請再試一次。",
  "report.excelReadyTitle": "Excel 檔案已準備完成",
  "report.excelGeneratedTitle": "Excel 檔案已成功產生！",
  "report.excelGeneratedMessage":
    "出勤報表已產生並可供下載。請點選下方下載按鈕，將檔案儲存到您的裝置。",
  "report.fileName": "檔案名稱：",
  "report.fileSize": "檔案大小：",
  "report.fileType": "檔案類型：",
  "report.excelWorkbook": "Excel 活頁簿（.xlsx）",
  "report.downloadExcel": "下載 Excel 檔案",
};

export const resources = {
  "en-PH": enPH,
  "zh-TW": zhTW,
};

export type Locale = keyof typeof resources;
export type TranslationKey = keyof typeof enPH;
